import type { SVGProps } from "react";
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#CE2222"
      d="m3 19 9-16 9 16zm2.823-1.684h12.354L12 6.368zM12 16.474a.78.78 0 0 0 .583-.242.83.83 0 0 0 .235-.6.83.83 0 0 0-.235-.6.78.78 0 0 0-.583-.242.78.78 0 0 0-.583.242.83.83 0 0 0-.235.6q0 .357.235.6a.78.78 0 0 0 .583.242m-.818-2.527h1.636v-4.21h-1.636z"
    />
  </svg>
);
export default SvgWarning;
